import { memo, type ReactNode } from "react";

import { Button, Card, CardContent, Input } from "@/common/components";

interface FilterBarProps {
  // Дата создания
  createdAt: string;
  onCreatedAtChange: (value: string) => void;
  createdAtError?: string | null;

  // Номер заявки
  orderNumber: string;
  onOrderNumberChange: (value: string) => void;
  additionalFilters?: ReactNode;

  // Кнопка сброса
  onReset: () => void;
  resetLabel?: string;

  className?: string;
}

export const FilterBar = memo(function FilterBar({
  createdAt,
  onCreatedAtChange,
  createdAtError,
  orderNumber,
  onOrderNumberChange,
  additionalFilters,
  onReset,
  resetLabel = "Сбросить",
  className,
}: FilterBarProps) {
  return (
    <Card className={className}>
      <CardContent>
        <div
          className={`grid grid-cols-1 gap-4 ${additionalFilters ? "md:grid-cols-2 xl:grid-cols-4" : "md:grid-cols-3"}`}
        >
          {/* Дата создания */}
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">
              Дата создания
            </label>
            <Input
              key="createdAt"
              type="date"
              name="createdAt"
              value={createdAt}
              onChange={(e) => onCreatedAtChange(e.target.value)}
              placeholder="ДД.ММ.ГГГГ"
              className={`block ${createdAtError ? "border-red-500" : ""}`}
            />
            {createdAtError && <p className="text-xs text-red-500 mt-1">{createdAtError}</p>}
          </div>

          {/* Номер заявки */}
          <div>
            <label className="block text-xs font-semibold text-Text-main leading-4 mb-1">
              Номер заявки
            </label>
            <Input
              placeholder="Введите № заявки"
              value={orderNumber}
              onChange={(e) => onOrderNumberChange(e.target.value)}
            />
          </div>

          {additionalFilters}

          {/* Кнопка сброса */}
          <div className="flex items-start mt-5">
            <Button
              variant="outline"
              className="w-full"
              onClick={(e) => {
                e.stopPropagation();
                onReset();
              }}
            >
              {resetLabel}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});
